<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="ការដកប្រាក់ទាំងអស់" name="first"></el-tab-pane>
			<!-- <el-tab-pane label="ដកប្រាក់ជោគជ័យ" name="second"></el-tab-pane>
			<el-tab-pane label="បដិសេធដកប្រាក់" name="third"></el-tab-pane> -->
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ លេខកូដប្រតិបត្តិការ ឈ្មោះអតិថិជន</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>ស្ថានភាពប្រតិបត្តិការ</label>
						<md-select placeholder="ស្ថានភាពប្រតិបត្តិការ (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option :value="0">រង់ចាំដកប្រាក់</md-option>
							<md-option :value="1">ដកប្រាក់ជោគជ័យ</md-option>
							<md-option :value="2">បដិសេធដកប្រាក់</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-30 md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>
			<md-table v-if="withdrawList.length > 0">
				<md-table-row>
					<!-- <md-table-head>ល.រ</md-table-head> -->
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដប្រតិបត្តិការ</md-table-head>
					<md-table-head>ចំនួនទឹកប្រាក់</md-table-head>
					<md-table-head>គណនីធនាគារ</md-table-head>
					<md-table-head>អតិថិជន</md-table-head>
					<md-table-head>អ្នកអនុម័ត</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(withdraw, index) in withdrawList">
					<md-table-cell>{{index+1}}</md-table-cell>
					<md-table-cell><b>{{withdraw.id}}</b><br>{{config.datelify(withdraw.created_date)}} ({{config.timelify(withdraw.created_date)}})</md-table-cell>
					<md-table-cell><b>{{config.moneylify(withdraw.amount)}}</b><br>{{withdraw.payment_type}}</md-table-cell>
					<md-table-cell><b>{{withdraw.account_name}}<br>{{withdraw.account_number}}</b></md-table-cell>
					<md-table-cell><b>{{withdraw.username}} <md-icon class="verify" v-if="withdraw.verified == 1">verified</md-icon> ({{config.moneylify(withdraw.balance)}})</b><br>{{withdraw.name}}</md-table-cell>
					<md-table-cell>
						<span v-if="withdraw.approve_by != null"><b>{{withdraw.approve_by}}</b><br>{{config.datelify(withdraw.approved_date)}} ({{config.timelify(withdraw.approved_date)}})</span>
						<span v-else><b>មិនមាន</b></span>
					</md-table-cell>
					<md-table-cell>
						<span class="late" v-if="withdraw.status == 0">{{ config.getWithdrawStatus(withdraw.status) }}</span>
						<span class="green" v-if="withdraw.status == 1">{{ config.getWithdrawStatus(withdraw.status) }}</span>
						<span class="error" v-if="withdraw.status == 2">{{ config.getWithdrawStatus(withdraw.status) }}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/withdraws/detail/' + withdraw.id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">មើលលំអិត</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>

				</md-table-row>
			</md-table>
			<h4 class="text-center" v-if="withdrawList.length == 0 && loadMore == true">មិនមានកញ្ចប់ឥវ៉ាន់</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>


		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបកញ្ចប់នេះពិតមែនទេ ?"
			md-content="ព័ត៌មានរបស់កញ្ចប់ឥវ៉ាន់នេះត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប"
			md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="onDelete" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			this.interval = setInterval(() => {
				this.searchHandler();
			}, 15000)
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					status: ""
				},
				interval:null,
				loadMore: false,
				withdrawList: []

			}
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/withdraw/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.withdrawList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.withdrawList = more ? this.withdrawList.concat(data.body.data) : data.body.data;
				})

			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/package/delete", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "កញ្ចប់ឥវ៉ាន់ត្រូវបានលុបចេញពីបញ្ចីដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						// this.getEndLicense();
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Withdraws/View.vue